<div>
  <evsb-label *ngIf="label" [label]="label.label" [name]="name" [className]="label?.className"></evsb-label>
  <div class="relative">
    <input
      type="date"
      class="body-small py-4 px-6 border border-grey focus:border-grey-dark60 focus:outline-none rounded-2xl w-full"
      [id]="id"
      [attr.max]="max"
      [attr.min]="min"
      [class]="className"
      [class.border-error]="error?.error"
      [(ngModel)]="value"
      />
      <div class="absolute top-0 h-full right-7 flex justify-right items-center">
        <svg-icon class="w-10 h-10 inline-block text-primary pointer-events-none" src="./assets/evsb/img/calendar.svg"></svg-icon>
      </div>
  </div>
  <evsb-error *ngIf="error" class="block mt-2" [error]="error.error" [className]="error?.className"></evsb-error>
</div>
